import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../context/userContext.js';
import BaseLayout from '../../components/BaseLayout.js';
import Card from '../../components/Card.js';
import Title from '../../components/Title.js';
import {ReactComponent as OliIcon} from '../../static/icons/404 - Oli.svg';

const NotFound = () => {
    document.title = "404 - Page Not Found";
    const navigate = useNavigate();
    const { user } = useUser();

    const handleBack = async (e) => {
      e.preventDefault();

      if (user) navigate('/dashboard');
      else navigate('/login');
    }

    return (
      <>
        <style>
          {`
            .form-container {
            margin: 0 auto;
            padding: 0 20%;
            display: flex;
            flex-direction: column;
            padding-top: 2%;
          }

          .card-content {
            max-height: calc(100vh - 300px);
            overflow-y: auto;
            overflow-x: hidden;
            scrollbar-width: thin;
            scrollbar-color: #6B3A8F rgba(26, 26, 26, 0.5);
            padding: 10px;
          }

          .remember-password {
            width: 100%;
            text-align: center;
          }

          .remember-password-button {
            color: #E1E1E6;
            font-family: 'Poppins', sans-serif;
            font-size: 12px;
            background: none;
            border: none;
            cursor: pointer;
          }

          .remember-password-button:hover {
            color: #9797FA;
          }

          .status-message {
            width: 100%;
            color: #E1E1E6;
            text-align: center;
            font-family: 'Poppins', sans-serif;
            font-size: 20px;
            font-style: normal;
            font-weight: 300;
            line-height: 140%;
            margin-top: 16px;
          }
          `}
        </style>
        <BaseLayout>
          <div className="form-container">
            <Card>
              <div className="card-content">
                <Title text="404 - Not Found"/>
                <div className="status-message">
                  <OliIcon width='60' height='60'/>
                  <p style={{marginTop: '16px'}}>Something went wrong...</p>
                </div>
                <div className="remember-password button-gap">
                  <button className="remember-password-button" type="button" onClick={handleBack}>
                    Go back?
                  </button>
                </div>
              </div>
            </Card>
          </div>
        </BaseLayout>
      </>
    );
  };
  
  export default NotFound;  